<template>
  <div>
    <v-autocomplete
      v-if="type===types[0]"
      v-model="selectedItem"
      :class="classNames"
      :hide-no-data="inputOnly"
      :items="searchResults"
      :search-input.sync="search"
      :filter="filter"
      box
      :dark="dark"
      color="#fff"
      :label="placeholder"
      item-text="label"
      item-value="item"
      @keyup.enter="onEnter"
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <v-list-tile-content
          v-if="typeof data.item !== 'object'"
          v-text="data.item"
        />

        <v-list-tile-content
          v-else
          @click="_selectItem(data.item)"
        >
          <v-list-tile-title
            v-if="data.item.id"
          >
            <b>ID:</b>
            {{ data.item.id }}
          </v-list-tile-title>

          <v-list-tile-sub-title v-if="data.item.first_name">
            <b>First Name:</b>
            {{ data.item.first_name }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title v-if="data.item.last_name">
            <b>Last Name:</b>
            {{ data.item.last_name }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title v-if="data.item.email">
            <b>Email:</b>
            {{ data.item.email }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </v-autocomplete>
    <v-autocomplete
      v-if="type===types[2]"
      v-model="selectedItem"
      :class="classNames"
      :hide-no-data="inputOnly"
      :items="searchResults"
      :search-input.sync="search"
      :filter="filter"
      box
      :dark="dark"
      color="#fff"
      :label="placeholder"
      item-text="label"
      item-value="item"
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <template v-if="typeof data.item !== 'object'">
          <v-list-tile-content v-text="data.item" />
        </template>
        <template v-else>
          <v-list-tile-content @click="_selectItem(data.item)">
            <v-list-tile-title v-if="data.item.name">
              <b>Label:</b>
              {{ data.item.name }}
            </v-list-tile-title>

            <v-list-tile-sub-title v-if="data.item.type">
              <b>Type:</b>
              {{ data.item.type }}
            </v-list-tile-sub-title>

            <v-list-tile-sub-title v-if="data.item.status">
              <b>Status:</b>
              {{ data.item.status }}
            </v-list-tile-sub-title>

            <v-list-tile-sub-title v-if="data.item.extOrderId">
              <b>Ext. Order ID:</b>
              {{ data.item.extOrderId }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </template>
    </v-autocomplete>
    <v-autocomplete
      v-if="type===types[1]"
      v-model="selectedItem"
      :class="classNames"
      :hide-no-data="inputOnly"
      :search-input.sync="search"
      :filter="filter"
      box
      :dark="dark"
      color="#fff"
      :label="placeholder"
      item-text="label"
      item-value="item"
      @click.native="onFocus"
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <template v-if="typeof data.item !== 'object'">
          <v-list-tile-content v-text="data.item" />
        </template>
        <template v-else>
          <v-list-tile-content @click="_selectItem(data.item)">
            <v-list-tile-title v-if="data.item.name">
              <b>Label:</b>
              {{ data.item.name }}
            </v-list-tile-title>

            <v-list-tile-sub-title v-if="data.item.type">
              <b>Type:</b>
              {{ data.item.type }}
            </v-list-tile-sub-title>

            <v-list-tile-sub-title v-if="data.item.status">
              <b>Status:</b>
              {{ data.item.status }}
            </v-list-tile-sub-title>

            <v-list-tile-sub-title v-if="data.item.extOrderId">
              <b>Status:</b>
              {{ data.item.extOrderId }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SearchItems',
  props: {
    selectItem: {
      type: Function,
      default: () => ({}),
    },
    getItems: {
      type: Function,
      default: null,
    },
    onFocus: {
      type: Function,
      default: () => ({}),
    },
    onEnter: {
      type: Function,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: '',
    },
    accountid: {
      type: String,
      default: '',
    },
    eventName: {
      type: String,
      default: '',
    },
    inputOnly: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    searchLength: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      accountId: this.accountid,
      loading: false,
      isUpdating: false,
      selectedItem: null,
      search: null,
      select: null,
      searchResults: [],
      types: ['users', 'accounts', 'orders'],
    };
  },
  computed: {
    classNames() {
      const searchType = this.$props.type;
      const classNames = ['searchInput', searchType];

      if (this.$props.inputOnly) {
        classNames.push('inputOnly');
      }

      return classNames;
    },
  },
  watch: {
    search: _.debounce(async function search(val) {
      const searchLen = this.searchLength ? this.searchLength : 3;
      if (!val || val.length < searchLen) {
        this.searchResults = [];
      } else if (val && val !== this.select) {
        this.querySelections(val);
      }
      if (this.eventName) {
        this.$root.$emit(this.eventName, val);
      }
    }, 600),
  },
  mounted() {
    this.accountId = this.$route.params.id;
  },
  methods: {
    filter(item, queryText) {
      if (!queryText) { this.searchResults = []; }

      return true;
    },
    remove() {
      this.searchResults = null;
    },
    _selectItem(item) {
      this.select = item;
      this.selectItem(item);
    },
    async querySelections(v) {
      this.loading = true;

      if (this.getItems) {
        const params = { accountId: this.accountId, query: v };
        const results = await this.getItems(params).then(data => data);
        this.searchResults = results.length > 0 ? results : [];
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">

  .searchInput {
    height: 60px;
  }
  .inputOnly {
    .theme--light.v-icon {
      display: none;
    }
    .v-input__icon {
      display: none;
    }
  }

 .v-list__tile {
    height: auto;
    padding-bottom: 5px;
  }


</style>



// WEBPACK FOOTER //
// src/components/shared/SearchItems.vue